import { useEffect, useState } from "react";
import { httpClient } from "../api/clients";
import { CONFIG_DATA } from "../api/endpoints";
import { useXplatContext } from "../context/XPlatContext";
import type { configurationData, errorData } from "../types";
import { getSubdomain, setLocalStoreage, getLocalStoreage } from "../helpers";

export function useConfigData() {
  const [error, setError] = useState<errorData | null>(null);
  const [configData, setConfigData] = useState<any>(null);
  const [configReady, setConfigReady] = useState(false);

  const { setLoading } = useXplatContext();

  useEffect(() => {
    const subdomain = getSubdomain();
    let cancelled = false;

    async function fetchConfigData() {
      try {
        setLoading(true);
        setError(null);

        // Check cached data with expiry
        const cachedData = getLocalStoreage(`configData_${subdomain}`);
        if (cachedData) {
          setConfigData(cachedData);
          setConfigReady(true);
          return;
        }

        // Otherwise, fetch from API
        const response = await httpClient.post(CONFIG_DATA.GET_CONFIG_DATA, {
          subdomain,
        });

        if (!cancelled && response?.data?.status === 200) {
          const rawData = response.data?.data;

          // Combine base_url with logo & icon if they exist
          const configData: configurationData = {
            ...rawData,
            logo: rawData?.logo ? `${rawData.base_url+rawData.logo}` : "",
            icon: rawData?.icon ? `${rawData.base_url+rawData.icon}` : "",
            estimate_enable: true
          };

          setConfigData(configData);
          // Save to localStorage with expiry - 24h
          setLocalStoreage(`configData_${subdomain}`, configData, 24);
          setConfigReady(true);
        }
      } catch (e: any) {
        const status = e?.response?.status;
        const message = e?.response?.data?.message || e?.message || "Invalid Client: Failed to load client configuration";

        if (!cancelled) setError({status: status,message: message});
      } finally {
        // if (!cancelled) setLoading(false);
      }
    }

    fetchConfigData();

    return () => {
      cancelled = true;
    };
  }, []);

  return { error, configData, configReady } as const;
}
